import { NgModule } from '@angular/core';
import { A11yTooltipModule } from '@mhe/ngx-shared/a11y-tooltip';
import { AlertModule } from '@mhe/ngx-shared/alert';
import { AutocompleteModule } from '@mhe/ngx-shared/autocomplete';
import { ButtonModule } from '@mhe/ngx-shared/button';
import { CheckboxModule } from '@mhe/ngx-shared/checkbox';
import { ChipModule } from '@mhe/ngx-shared/chip';
import { CollapseModule } from '@mhe/ngx-shared/collapse';
import { CopyrightModule } from '@mhe/ngx-shared/copyright';
import { DataTableModule } from '@mhe/ngx-shared/data-table';
import { DateTimeModule } from '@mhe/ngx-shared/date-time';
import { DatepickerModule } from '@mhe/ngx-shared/datepicker';
import { DialogModalModule } from '@mhe/ngx-shared/dialog-modal';
import { DragAndDropModule } from '@mhe/ngx-shared/dragdrop';
import { DropdownModule } from '@mhe/ngx-shared/dropdown';
import { FileUploadModule } from '@mhe/ngx-shared/file-upload';
import { InputModule } from '@mhe/ngx-shared/input';
import { MathJaxModule } from '@mhe/ngx-shared/mathjax';
import { ModalModule } from '@mhe/ngx-shared/modal';
import { OverlayModule } from '@mhe/ngx-shared/overlay';
import { PagerModule } from '@mhe/ngx-shared/pager';
import { PopoverModule } from '@mhe/ngx-shared/popover';
import { RadioButtonModule } from '@mhe/ngx-shared/radio-button';
import { RequiredIndicatorModule } from '@mhe/ngx-shared/required-indicator';
import { SpinnerModule } from '@mhe/ngx-shared/spinner';
import { TabsModule } from '@mhe/ngx-shared/tabs';
import { TagPillModule } from '@mhe/ngx-shared/tag-pill';
import { TextAreaModule } from '@mhe/ngx-shared/textarea';
import { TimeFormatModule } from '@mhe/ngx-shared/time-format';
import { TimeoutModalModule } from '@mhe/ngx-shared/timeout-modal';
import { ToggleModule } from '@mhe/ngx-shared/toggle';
import { ToggletipModule } from '@mhe/ngx-shared/toggletip';
import { TooltipModule } from '@mhe/ngx-shared/tooltip';
import { NGX_SHARED_CONFIG } from './config/config.token';
import * as i0 from "@angular/core";
/**
 * @deprecated since version 9.
 * Prefer individual entry-points i.e. `@mhe/ngx-shared/popover`
 */
export class NgxSharedModule {
    /**
     * @deprecated since version 9.
     * Prefer using the NGX_SHARED_CONFIG injection token directly
     */
    static forRoot(config) {
        return {
            ngModule: NgxSharedModule,
            providers: [{ provide: NGX_SHARED_CONFIG, useValue: config }],
        };
    }
}
NgxSharedModule.ɵfac = function NgxSharedModule_Factory(t) { return new (t || NgxSharedModule)(); };
NgxSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NgxSharedModule });
NgxSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AlertModule,
        AutocompleteModule,
        A11yTooltipModule,
        ButtonModule,
        CheckboxModule,
        ChipModule,
        CollapseModule,
        CopyrightModule,
        DatepickerModule,
        DateTimeModule,
        DialogModalModule,
        DragAndDropModule,
        DropdownModule,
        FileUploadModule,
        InputModule,
        ModalModule,
        OverlayModule,
        PagerModule,
        PopoverModule,
        RadioButtonModule,
        RequiredIndicatorModule,
        DataTableModule,
        SpinnerModule,
        TabsModule,
        TagPillModule,
        TextAreaModule,
        TimeFormatModule,
        ToggleModule,
        TooltipModule,
        ToggletipModule,
        TimeoutModalModule,
        MathJaxModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NgxSharedModule, [{
        type: NgModule,
        args: [{
                exports: [
                    AlertModule,
                    AutocompleteModule,
                    A11yTooltipModule,
                    ButtonModule,
                    CheckboxModule,
                    ChipModule,
                    CollapseModule,
                    CopyrightModule,
                    DatepickerModule,
                    DateTimeModule,
                    DialogModalModule,
                    DragAndDropModule,
                    DropdownModule,
                    FileUploadModule,
                    InputModule,
                    ModalModule,
                    OverlayModule,
                    PagerModule,
                    PopoverModule,
                    RadioButtonModule,
                    RequiredIndicatorModule,
                    DataTableModule,
                    SpinnerModule,
                    TabsModule,
                    TagPillModule,
                    TextAreaModule,
                    TimeFormatModule,
                    ToggleModule,
                    TooltipModule,
                    ToggletipModule,
                    TimeoutModalModule,
                    MathJaxModule,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(NgxSharedModule, { exports: [AlertModule,
        AutocompleteModule,
        A11yTooltipModule,
        ButtonModule,
        CheckboxModule,
        ChipModule,
        CollapseModule,
        CopyrightModule,
        DatepickerModule,
        DateTimeModule,
        DialogModalModule,
        DragAndDropModule,
        DropdownModule,
        FileUploadModule,
        InputModule,
        ModalModule,
        OverlayModule,
        PagerModule,
        PopoverModule,
        RadioButtonModule,
        RequiredIndicatorModule,
        DataTableModule,
        SpinnerModule,
        TabsModule,
        TagPillModule,
        TextAreaModule,
        TimeFormatModule,
        ToggleModule,
        TooltipModule,
        ToggletipModule,
        TimeoutModalModule,
        MathJaxModule] }); })();
